/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'pages.audit.desc':
    '审计日志记录了所有平台用户进行的关键操作，无论是管理员进行的批量操作、还是用户侧进行的多因素认证，都可以在这里找到对应的记录，以对某次改变提供充分的溯源数据。',
  'pages.audit.user': '用户行为',
  'pages.audit.admin': '管理员行为',
  'pages.audit.columns.event_type': '事件类型',
  'pages.audit.columns.event_type.placeholder': '请选择事件类型',
  'pages.audit.columns.username': '操作者',
  'pages.audit.columns.user_id': '操作者 ID',
  'pages.audit.columns.user_type': '操作者类型',
  'pages.audit.columns.user_type.user': '用户',
  'pages.audit.columns.user_type.admin': '管理员',
  'pages.audit.columns.username.placeholder': '请输入用户名',
  'pages.audit.columns.geo_location': '客户端IP',
  'pages.audit.columns.platform': '操作系统',
  'pages.audit.columns.browser': '浏览器',
  'pages.audit.columns.event_time': '事件时间',
  'pages.audit.columns.event_status': '事件状态',
  'pages.audit.columns.event_content': '事件内容',
  'pages.audit.columns.device_type': '设备类型',
  'pages.audit.columns.operate_system': '操作系统',
  'pages.audit.columns.client_ip': '客户端IP',
  'pages.audit.columns.country': '国家',
  'pages.audit.columns.province': '省份',
  'pages.audit.columns.city': '城市',
  'pages.audit.columns.event_object': '操作对象',
  'pages.audit.columns.event_object.id': '对象 ID：',
  'pages.audit.columns.event_object.type': '对象类型：',
};
